import { render } from "./ProfileVerified.vue?vue&type=template&id=511560fc"
import script from "./ProfileVerified.vue?vue&type=script&lang=js"
export * from "./ProfileVerified.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__